import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { t } from "../lib/i18n";
import AdminBadge from "../components/AdminBadge";

export default function Players() {
  const [players, setPlayers] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/players").then((r) => setPlayers(r.data.filter((p) => !p.is_banned))).catch(() => {});
  }, []);
  const filtered = players.filter(
    (p) =>
      p.handle.toLowerCase().includes(q.toLowerCase()) ||
      (p.real_name || "").toLowerCase().includes(q.toLowerCase()) ||
      p.country.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="flex items-end justify-between border-b border-white/10 pb-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FF0055] font-mono">
            // Roster
          </div>
          <h1 className="font-display font-black uppercase italic text-5xl sm:text-6xl mt-2">
            {t.rosterTitle}
          </h1>
        </div>
        <input
          data-testid="player-search"
          placeholder={t.search}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="bg-transparent border border-white/15 px-4 py-2 text-sm font-mono uppercase tracking-[0.2em] focus:outline-none focus:border-[#00E5FF] w-56"
        />
      </div>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
        {filtered.map((p) => (
          <Link
            key={p.id}
            to={`/players/${p.id}`}
            data-testid={`player-card-${p.id}`}
            className="group border border-white/10 bg-[#0C0C14] p-5 hover:border-[#FF0055]/60 transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-mono text-white/40 px-1.5 py-0.5 border border-white/10">
                {p.country}
              </span>
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#00E5FF]">
                {p.points} {t.pts}
              </span>
            </div>
            <div className="font-display font-black uppercase italic text-2xl mt-3 group-hover:text-[#FF0055] transition-colors flex items-center gap-2">
              <span className="truncate">{p.handle}</span>
              {p.is_admin && <AdminBadge />}
            </div>
            <div className="text-xs text-white/50 mt-1">{p.real_name}</div>
            <div className="mt-4 flex gap-3 text-xs font-mono">
              <span className="text-[#00E5FF]">{p.wins}W</span>
              <span className="text-white/40">{p.losses}L</span>
              <span className="text-white/30 ml-auto">
                {((p.wins / Math.max(1, p.wins + p.losses)) * 100).toFixed(0)}%
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
